import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import { shared } from './shared';

// Registers a synchronous frame-capture hook so the HUD can turn the current
// view into a shareable postcard. Renders + reads the buffer in the same tick,
// so no preserveDrawingBuffer (and its constant perf cost) is needed.
export default function PostcardCapture() {
  const gl = useThree((s) => s.gl);
  const scene = useThree((s) => s.scene);
  const camera = useThree((s) => s.camera);

  useEffect(() => {
    shared.capturePostcard = () => {
      try {
        gl.render(scene, camera);
        return gl.domElement.toDataURL('image/jpeg', 0.92);
      } catch (e) {
        return null;
      }
    };
    return () => { shared.capturePostcard = null; };
  }, [gl, scene, camera]);

  return null;
}
